import { environment } from './../environments/environment';

export const API_JAVA_AUTH = environment.api_java_auth;

export const API_JAVA_CONSULTA_PERFIL_SERVICO = environment.api_java_consulta_lista_servicos;
export const API_JAVA_BUSCA_CONTRATO_REGISTRO = environment.api_java_busca_contrato_registro;

export const API_JAVA_CONSULTA_RESTRITO_FUG = environment.api_java_consulta_restrito_fug;
export const API_JAVA_CONSULTA_RESTRITO_ISO = environment.api_java_consulta_restrito_iso;

export const API_JAVA_GRAVA = environment.api_java_grava;
export const API_JAVA_RENOVA = environment.api_java_renova;

export const API_JAVA_CERT_BLOQ = environment.api_java_cert_bloq;
export const API_JAVA_CONSULTA_SITUACAO_CERT = environment.api_java_consulta_situacao_cert;
export const API_JAVA_VERIFICA_LCR = environment.api_java_verifica_lcr;


//export const API_NODE = environment.api_node;

export const API_JAVA_AUTH_IMPRESSAO = environment.api_java_auth_impressao;
export const API_JAVA_SERVICO_IMPRESSAO = environment.api_java_servico_impressao;


//MANUAL
export const MANUAL_CNS = environment.manual_cns;

export const API_CNS_PORTAL = environment.api_cns_portal;

export const ST_NONCE_INI = environment.st_nonce_ini;
export const ST_NONCE_FIM = environment.st_nonce_fim;


export const API_DOWNLOAD_KRYPTONITA = environment.api_download_kriptonita;





